import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardMedia, Paper } from '@material-ui/core';
import { IconButton, TextField } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../knock-design-system';

const useCss = makeCss((theme) => ({
  cardContent: {
    padding: '16px 8px',
  },
  cardMedia: {
    height: '200px',
    width: '200px',
    objectFit: 'contain',
  },
  deleteButton: {
    color: theme.palette.common.white,
    background: theme.palette.action['hover-light-30-p'],
  },
  deleteButtonWrapper: {
    position: 'absolute',
    top: '8px',
    right: '8px',
  },
  imageWrapper: {
    position: 'relative',
    overflow: 'hidden',
  },
  previewCard: {
    width: '200px',
  },
}));

const ImageCard = memo(
  ({
    cardAriaLabel,
    children,
    className,
    deleteImageFile,
    description,
    imageUrl,
    isDescriptionVisible,
    updateDescription,
  }) => {
    const css = useCss();

    const handleDescriptionBlur = (e) => {
      const { value } = e.target;
      updateDescription(value.trim());
    };

    const handleDescriptionOnChange = (value) => {
      updateDescription(value);
    };

    const handleDeleteOnClick = () => {
      deleteImageFile(imageUrl);
    };

    return (
      <Card
        aria-label={cardAriaLabel}
        className={className}
        css={css.previewCard}
        elevation={0}
      >
        <Paper css={css.imageWrapper} variant="outlined">
          <div css={css.deleteButtonWrapper}>
            <IconButton
              aria-label="remove"
              color="secondary"
              css={css.deleteButton}
              iconName="trash-bin"
              tooltipText="remove"
              onClick={handleDeleteOnClick}
            />
          </div>

          {children}

          <CardMedia css={css.cardMedia} component="img" src={imageUrl} />
        </Paper>

        {isDescriptionVisible && (
          <CardContent css={css.cardContent}>
            <TextField
              fullWidth
              label="Description"
              onBlur={handleDescriptionBlur}
              onChange={handleDescriptionOnChange}
              value={description || ''}
              variant="outlined"
            />
          </CardContent>
        )}
      </Card>
    );
  },
);

ImageCard.displayName = 'ImageCard';

ImageCard.propTypes = {
  cardAriaLabel: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  deleteImageFile: PropTypes.func,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  isDescriptionVisible: PropTypes.bool,
  updateDescription: PropTypes.func,
};

export default ImageCard;
